<ngx-loading [show]="loading" [config]="{backdropBorderRadius: '14px'}"></ngx-loading>
<h2 mat-dialog-title class="bgDialogHeader text-center">Add New Protocol
  <div class="pull-right">
    <a class="boxclose" (click)="onNoClick()"></a>
  </div>
</h2>
<mat-dialog-content class="mat-typography">
  <nb-card class="card-protocol">
    <form class="form-horizontal" [formGroup]="formProtocol">
      <div class="col-md-12">
        <mat-form-field class="col-md-6">
          <mat-label>Service</mat-label>
          <mat-select formControlName="serviceType" matNativeControl placeholder="Service" required
            (selectionChange)="getSubServices($event);">
            <mat-option *ngFor="let service of services;" [value]="service.VendorServiceTypeID">
              {{service.VendorServiceTypeName}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="formProtocol.controls.serviceType.touched && formProtocol.controls.serviceType.errors"
            class="error">
            Please select service.
          </mat-error>
        </mat-form-field>

        <mat-form-field class="col-md-6">
          <mat-label>Sub Service</mat-label>
          <mat-select formControlName="subServiceType" matNativeControl placeholder="Service" required>
            <mat-option *ngFor="let subService of subServices;" [value]="subService.VendorServiceToSubServiceMappingID">
              {{subService.VendorSubServiceTypeName}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="formProtocol.controls.subServiceType.touched && formProtocol.controls.subServiceType.errors"
            class="error">
            Please select sub service.
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-12">
        <mat-form-field class="col-md-12">
          <textarea matInput placeholder="Protocol" formControlName="protocolDescription"></textarea>
          <mat-error *ngIf="formProtocol.controls.protocolDescription.touched && formProtocol.controls.protocolDescription.errors"
            class="error">
            Please enter protocol description.
          </mat-error>
        </mat-form-field>
      </div>
    </form>
  </nb-card>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button class="btn btn-success btn-semi-round btn-demo bgBlue pull-right mr-2" (click)="saveProtocol()" [disabled]="!formProtocol.valid"> Save
  </button>
  <button (click)="onNoClick()" class="btn btn-success btn-semi-round btn-demo bgBlue pull-right"> Close </button>
</mat-dialog-actions>